import classNames from 'classnames'
import { useState } from 'react'

import type { ReactElement } from 'react'

import ScoreTable from './ScoreTable'

import CollapseButton from '~/components/Buttons/CollapseButton'
import SkeletonLoader from '~/components/SkeletonLoader'
import { useGlobalStatsQuery } from '~/queries/clusters'
import { formatValue } from '~/utils/number'

import './styles.scss'

const MetricsBlock = (): ReactElement => {
  /** Local state */

  const [isTableCollapsed, setIsTableCollapsed] = useState(false)

  const detailsClasses = classNames('cluster-list__metrics-block-component__details-content', {
    'cluster-list__metrics-block-component__details-content--visible': !isTableCollapsed,
  })

  /** Queries & Mutations */

  const { data: metrics, isLoading: isStatsLoading } = useGlobalStatsQuery()

  /** Handlers */

  const handleToggleClick = (toggleState: boolean) => () => setIsTableCollapsed(toggleState)

  /** Render */

  return isStatsLoading ? (
    <div className="cluster-list__metrics-block-skeleton">
      <SkeletonLoader />
    </div>
  ) : metrics ? (
    <div className="cluster-list__metrics-block-component">
      <div className="main-content">
        {metrics.nb_apps ? (
          <div className="metric-tuple">
            Apps <span className="metric-tuple-value">{formatValue(metrics.nb_apps)}</span>
          </div>
        ) : null}
      </div>
      <div className={detailsClasses}>
        <ScoreTable metrics={metrics} />
      </div>
      <CollapseButton isCollapsed={isTableCollapsed} onClick={handleToggleClick(!isTableCollapsed)} />
    </div>
  ) : (
    <div>No metrics available</div>
  )
}

export default MetricsBlock
